export enum ProgressItemStatus {
    ToDo = "ToDo",
    InProgress = "InProgress",
    Done = "Done",
}

export class ProgressItemStatusMetadata {
    public static readonly ToDo = new ProgressItemStatusMetadata(ProgressItemStatus.ToDo, "To do", "#9aadbd");
    public static readonly InProgress = new ProgressItemStatusMetadata(ProgressItemStatus.InProgress, "In progress", "#E1B94A");
    public static readonly Done = new ProgressItemStatusMetadata(ProgressItemStatus.Done, "Done", "#00c875");

    public static readonly All = [
        ProgressItemStatusMetadata.ToDo,
        ProgressItemStatusMetadata.InProgress,
        ProgressItemStatusMetadata.Done,
    ];

    public static readonly ByStatus: { [status in ProgressItemStatus]: ProgressItemStatusMetadata } = {
        [ProgressItemStatus.ToDo]: ProgressItemStatusMetadata.ToDo,
        [ProgressItemStatus.InProgress]: ProgressItemStatusMetadata.InProgress,
        [ProgressItemStatus.Done]: ProgressItemStatusMetadata.Done,
    };

    private constructor(
        public readonly status: ProgressItemStatus,
        public readonly name: string,
        public readonly colour: string,
    ) { }
}
